<ng-template #bookingStatusChangeConfirmationModal let-modal>
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                id="close-support-ticket-close-confirmation-modal" (click)="closeModal()"></button>
        </div>
        <div class="modal-body">
            <div class="mt-2">
                <div class="text-center">
                    @if (isCancelBooking) {
                    <em class="mdi mdi-car-off" style="font-size: 80px; color: #f06548"></em>
                    } @else if (this.getNextBookingStatus() !== this.helper.BookingStatus.ARRIVED_AT_DESTINATION) {
                    <em class="ri-taxi-fill" style="font-size: 80px; color: #f06548"></em>
                    }
                </div>
                <div class="mt-2 pt-2 fs-15 mx-4 mx-sm-5 text-center">
                    <!-- QA BUG-004: plain sentences; the old i18n string printed a literal "To Status". -->
                    @if (isCancelBooking) {
                    <h4>Cancel trip #{{ bookingDetails?.uniqueId }}?</h4>
                    <p>This can&#39;t be undone. The driver and customer are told the trip is cancelled.</p>
                    } @else {
                    <h4>Change trip #{{ bookingDetails?.uniqueId }} to {{ getBookingStatusString(currentBookingBusinessType) }}?</h4>
                    <p>Please confirm this status change.</p>
                    }
                </div>
                <form [formGroup]="completeBookingDetailsForm">
                    <div class="row">
                        @if ((getNextBookingStatus(currentBookingBusinessType) === helper.BookingStatus.ARRIVED_AT_DESTINATION && (currentBookingBusinessType === helper.BusinessType.TAXI || currentBookingBusinessType === helper.BusinessType.TAXI_METER || currentBookingBusinessType === helper.BusinessType.TOWING)) &&
            !isCancelBooking) {
            <div class="col-12 mb-2">
              <label for="booking-complete-address">{{ "label-title.address" | translate }}</label>
              <input
                class="form-control"
                id="booking-complete-address"
                formControlName="completeAddress"
                placeholder="{{ 'label-title.enter-address' | translate }}"
                (input)="onCompleteAddressInputChange($event)"
                autocomplete="off"
              />
              @if(completedAddressPredictions.length > 0) {
              <ul class="autocomplete-dropdown" id="complete-address-autocomplete-google-dropdown">
                @for (prediction of completedAddressPredictions; track $index) {
                <li class="text-ellipsis" [class.selected]="isCompletedAddressSelected($index)" id="complete-address-autocomplete-google-dropdown-item-{{ $index }}">
                  <a href="javascript:void(0);" (click)="onPredictionSelect(prediction)">{{ prediction.description }}</a>
                </li>
                }
                <img src="../../../../assets/images/default-images/google_images/google_on_white.png" alt="Google Logo" class="p-2" />
              </ul>
              } @if (completedAddressMapBoxSuggestions.length > 0) {
              <ul class="autocomplete-dropdown" id="complete-address-autocomplete-mapbox-dropdown">
                @for (suggestion of completedAddressMapBoxSuggestions; track $index) {
                <li [class.selected]="isCompletedAddressSelected($index)" id="complete-address-autocomplete-mapbox-dropdown-item-{{ $index }}">
                  <a href="javascript:void(0);" (click)="onSelect(suggestion)">{{ suggestion.place_name }}</a>
                </li>
                }
              </ul>
              } @if(completeBookingDetailsForm.get('completeAddress')?.errors && completeBookingDetailsForm.get('completeAddress')?.touched &&
              completeBookingDetailsForm.get('completeAddress')?.errors?.['required']){
              <div class="invalid-message">
                <p class="m-0">{{ "label-title.address" | translate }} {{ "label-title.is-required" | translate }}</p>
              </div>
              }
            </div>

            @if (bookingDetaisAdditionalPrices.length > 0) {
            <div formArrayName="prices">
              <div *ngFor="let priceControl of prices.controls; let i = index" [formGroupName]="i">
                <div class="col-12 mb-2">
                  <label [for]="'price' + i">{{ bookingDetaisAdditionalPrices[i].title }}</label>
                  <input
                    type="number"
                    [id]="'price' + i"
                    class="form-control"
                    formControlName="price"
                    placeholder="{{ 'label-title.price' | translate }}"
                    disablePasteDrop
                    (keypress)="helper.numberValidation($event)"
                  />
                  @if(priceControl.get('price')?.errors && priceControl.get('price')?.touched){
                  <div class="invalid-message">
                    <p class="m-0 mt-1">
                      @if (priceControl.get('price')?.errors?.['required']) {
                      {{ "label-title.price" | translate }} {{ "label-title.is-required" | translate }}
                      } @else if (priceControl.get('price')?.errors?.['minValue']) {
                      {{ "validation-title.number-greater-than-or-equal-zero" | translate }}
                      }
                    </p>
                  </div>
                  }
                </div>
              </div>
            </div>
            }} @if (isCancelBooking) {
                        <div class="col-12 mb-2">
                            @if(cancellationCharge){
                            <label for="booking-cancellation-reason" class="d-flex">{{ "label-title.cancellation-charge"
                                | translate
                                }} : <span class="d-flex currency-gap ms-1">
                                    {{cancellationCharge?.toFixed(decimalPointValue)}}
                                    <span
                                        [ngClass]="{ 'order-first': setCurrencySign == helper.SetCurrencySignUnit.LEFT }">
                                        {{ currencySign }}
                                    </span>
                                </span>
                            </label>
                            }
                        </div>
                        <div class="col-12 mb-2">
                            <label for="booking-cancellation-reason">{{ "label-title.cancellation-reason" | translate
                                }}</label>
                            <ng-select id="booking-cancellation-reason"
                                notFoundText="{{ 'label-title.no-data-found' | translate }}" appearance="outline"
                                labelForId="type" [searchable]="true" [clearable]="false"
                                placeholder="{{ 'label-title.enter-cancellation-reason' | translate }}"
                                formControlName="cancellationReason" (change)="onReasonChange()">
                                @for (cancelBookingReason of cancelBookingReasonList; track $index) {
                                <ng-option [value]="cancelBookingReason.reasons">{{
                                    cancelBookingReason.reasons }}</ng-option>
                                }
                                <ng-option value="other">{{ 'label-title.other' | translate}}</ng-option>
                            </ng-select>
                            @if(completeBookingDetailsForm.get('cancellationReason')?.errors &&
                            completeBookingDetailsForm.get('cancellationReason')?.touched &&
                            completeBookingDetailsForm.get('cancellationReason')?.errors?.['required']){
                            <div class="invalid-message">
                                <p class="m-0">{{ "label-title.cancellation-reason" | translate }} {{
                                    "label-title.is-required" | translate }}</p>
                            </div>
                            }
                        </div>
                        }
                        @if(completeBookingDetailsForm.value.cancellationReason === 'other'){
                        <div class="col-12 mb-2">
                            <textarea name="" id="" class="form-control" id="reason" formControlName="reason"
                                placeholder="{{ 'label-title.write-specific-reason' | translate }}"
                                autocomplete="off"></textarea>
                            @if(completeBookingDetailsForm.get('reason')?.errors &&
                            completeBookingDetailsForm.get('reason')?.touched &&
                            completeBookingDetailsForm.get('reason')?.errors?.['required']){
                            <div class="invalid-message">
                                <p class="m-0">{{ "label-title.cancellation-reason" | translate }} {{
                                    "label-title.is-required" | translate }}</p>
                            </div>
                            }
                        </div>
                        }
                        <div class="col-12 mb-2">
                            <label for="booking-complete-note">{{ "label-title.note" | translate }}</label>
                            <input class="form-control" id="booking-complete-note" formControlName="note" placeholder="{{ 'label-title.enter-note' | translate }}" autocomplete="off" />
                          </div>
                    </div>
                </form>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button type="button" id="status-change-keep" class="btn w-sm btn-light" (click)="closeModal()">{{ isCancelBooking ? 'Keep trip' : 'Back' }}</button>
                <button id="close-support-ticket"
                    class="btn w-sm btn-danger btn-load d-flex align-items-center justify-content-center"
                    style="overflow: unset" [ngClass]="{ 'pointer-events-none': helper.showBtnLoader[1] }"
                    (click)="isCancelBooking ? cancelBooking() : updateBookingStatus()">
                    <span class="d-flex align-items-center" id="close-support-ticket-button">
                        @if (helper.showBtnLoader[1]) {
                        <span class="spinner-border flex-shrink-0">
                            <span class="visually-hidden"></span>
                        </span>
                        } @else {
                        <span class="flex-grow-1" [ngClass]="{ 'ms-2': helper.showBtnLoader[1] }"
                            id="close-support-ticket-button-text">
                            @if (isCancelBooking) {
                            Cancel trip
                            } @else if (this.getNextBookingStatus() !==
                            this.helper.BookingStatus.ARRIVED_AT_DESTINATION) {
                            Change status
                            } @else {
                            Complete trip
                            }
                        </span>
                        }
                    </span>
                </button>
            </div>
        </div>
    </div>
</ng-template>